import {
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Input from "../../../components/Commons/Input";
import { Select } from "../../../components/Commons/Select";
import { useTranslation } from "react-i18next";
import {
  positions,
  occupationSelect,
  businessAndManagementJobs,
  creativeAndDesignJobs,
  environmentAndInfrastructureJobs,
  informationAndTechnologyJobs1,
  informationAndTechnologyJobs2,
  other,
} from "../../../utils/constants/constant";
import { Regex } from "../../../utils/constants";
import Minus from "../../../components/svg/Minus";
import Plus from "../../../components/svg/Plus";
import { useGlobalState } from "../../../contexts/GlobalContext";
import ErrorMsg from "../../../components/Commons/ErrorMsg";

const BasicInfo: React.FC<IBasicInterestsFormProps> = (props) => {
  const { t } = useTranslation();
  const { globalState } = useGlobalState();
  const { user } = globalState ?? {};
  const { family_name, given_name } = user ?? {};

  const {
    isEdit = true,
    onChangeData,
    onChangeValidate,
    formData,
    errorMess,
    onGetErr,
    isShow = false,
    isShowPosition = false,
    id,
  } = props;
  const [state, setState] = useState<IBasicInterestsFormState>({
    userMetaData: {},
  });
  const { userMetaData } = state;

  const [errors, setErrors] = useState({
    last_name: "",
    first_name: "",
    last_name_kana: "",
    first_name_kana: "",
    gender: "",
    birth_day: "",
    contactType: "",
    occupationCode: "",
    day: "",
    month: "",
    year: "",
    positionCode: "",
    phoneNumber: "",
    postalCode:"",
    affiliationCodes: "",
  });

  const [days, setDays] = useState<ISelectItem[]>([
    { value: "0", label: "日" },
  ]);
  const currentYear = new Date().getFullYear();
  const defaultDaysInMonth = 31;
  const [visibleForms, setVisibleForms] = useState<{ [key: string]: boolean }>({
    information: true,
    interests: true,
  });

  const handleClickIconVisibleForm = (key: string) => {
    setVisibleForms((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const calculateDaysInMonth = (year: number, month: number) => {
    if (month === 0) return defaultDaysInMonth;
    return new Date(year, month, 0).getDate();
  };

  useEffect(() => {
    const year =
      parseInt(userMetaData?.profile?.birth?.year?.toString() ?? "0") ||
      currentYear;
    const month =
      parseInt(userMetaData?.profile?.birth?.month?.toString() ?? "0") || 1;
    const daysInMonth = calculateDaysInMonth(year, month);

    const dayOptions: ISelectItem[] = [{ value: "0", label: "日" }];
    for (let i = 1; i <= daysInMonth; i++) {
      dayOptions.push({ value: i.toString(), label: `${i}日` });
    }

    if (
      userMetaData?.profile?.birth?.month?.toString() !== "0" &&
      parseInt(userMetaData?.profile?.birth?.day?.toString() ?? "0") >
        daysInMonth
    ) {
      setState((prevData) => ({
        ...prevData,
        userMetaData: {
          ...prevData.userMetaData,
          profile: {
            ...prevData.userMetaData?.profile,
            birth: {
              ...prevData.userMetaData?.profile?.birth,
              day: undefined,
            },
          },
        },
      }));
    }

    setDays(dayOptions);
  }, [
    userMetaData?.profile?.birth?.month,
    userMetaData?.profile?.birth?.year,
    userMetaData?.profile?.birth?.day,
  ]);

  const years: ISelectItem[] = [{ value: "0", label: "年" }];
  for (let i = 0; i < 100; i++) {
    years.push({
      value: (currentYear - i).toString(),
      label: `${(currentYear - i).toString()}年`,
    });
  }

  const months: ISelectItem[] = [{ value: "0", label: "月" }];
  for (let i = 1; i <= 12; i++) {
    months.push({ value: i.toString(), label: `${i.toString()}月` });
  }

  useEffect(() => {
    if (formData) {
      setState((prevState) => {
        if (JSON.stringify(prevState.userMetaData) !== JSON.stringify(formData)) {
          if ((family_name || given_name) && !formData.profile?.fullName?.firstName && !formData.profile?.fullName?.lastName) {
            return {
              ...prevState,
              userMetaData: {
                ...prevState.userMetaData,
                profile: {
                  ...prevState?.userMetaData?.profile,
                  fullName: {
                    firstName: given_name ?? "",
                    lastName: family_name ?? "",
                  },
                },
              },
            };
          }
          return {
            ...prevState,
            userMetaData: {
              ...formData,
            },
          };
        }
        return prevState;
      });
    }
  }, [formData]);

  useEffect(() => {
    if (onChangeData) {
      onChangeData(userMetaData ?? {});
    }
    if (onChangeValidate) {
      onChangeValidate(handleCountCurrentValid());
    }
    if (onGetErr) {
      onGetErr(errors.day || errors.month || errors.year ? true : false);
    }
  }, [state, errors]);

  useEffect(() => {
    if (errorMess && errorMess.length > 0) {
      errorMess.forEach((error) => {
        setErrors((prevErrors) => {
          if (error.field && Object.keys(prevErrors).includes(error.field)) {
            return {
              ...prevErrors,
              [error.field]: error.mess,
            };
          }
          return prevErrors;
        });
      });
    }
  }, [errorMess]);

  useEffect(() => {
    checkFutureDate();
  }, [userMetaData?.profile?.birth]);

  const checkFutureDate = () => {
    if (
      userMetaData?.profile?.birth?.year != 0 &&
      userMetaData?.profile?.birth?.month != 0 &&
      userMetaData?.profile?.birth?.day != 0 &&
      errors.day
    ) {
      const birthDate = new Date(
        parseInt(userMetaData?.profile?.birth?.year?.toString() ?? "0"),
        parseInt(userMetaData?.profile?.birth?.month?.toString() ?? "0") - 1,
        parseInt(userMetaData?.profile?.birth?.day?.toString() ?? "0")
      );
      const currentDate = new Date();
      if (birthDate <= currentDate) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          day: "",
        }));
      }
    }
  };

  const handleCountCurrentValid = () => {
    let fields;
    if (isShow) {
      fields = [
        {
          field: userMetaData?.profile?.fullName?.firstName,
          valid: !errors.first_name,
        },
        {
          field: userMetaData?.profile?.fullName?.lastName,
          valid: !errors.last_name,
        },
        {
          field: userMetaData?.profile?.fullNameKana?.firstName,
          valid: !errors.first_name_kana,
        },
        {
          field: userMetaData?.profile?.fullNameKana?.lastName,
          valid: !errors.last_name_kana,
        },
        {
          field:
            userMetaData?.profile?.birth?.year &&
            userMetaData?.profile?.birth?.month &&
            userMetaData?.profile?.birth?.day,
          valid: !errors.year && !errors.day && !errors.month,
        },
        {
          field: userMetaData?.profile?.occupationCode != undefined ? userMetaData?.profile?.occupationCode : null,
          valid: !errors.occupationCode,
        },
        {
          field: userMetaData?.workPlaceInfo?.positionCode ? userMetaData?.workPlaceInfo?.positionCode : null,
          valid: !errors.positionCode,
        },
        {
          field:
          (userMetaData?.workPlaceInfo?.affiliationCodes &&
          userMetaData?.workPlaceInfo?.affiliationCodes.length > 0) ? userMetaData?.workPlaceInfo?.affiliationCodes : null,
          valid: !errors.affiliationCodes,
        },
        {
          field: userMetaData?.profile?.contactType,
          valid: !errors.contactType,
        },
      ];
    }

    if(isShowPosition) {
      fields = [
        {
          field: userMetaData?.workPlaceInfo?.positionCode,
          valid: !errors.positionCode,
        },
        {
          field:
            userMetaData?.workPlaceInfo?.affiliationCodes &&
            userMetaData?.workPlaceInfo?.affiliationCodes.length > 0,
          valid: !errors.affiliationCodes,
        },
      ];
    }

    return fields && fields.reduce((currentValid, { field, valid }) => {
      return field || field == 0 && valid ? currentValid + 1 : currentValid;
    }, 0);
  };

  const validateField = (field: string, value?: string) => {
    switch (field) {
      case "last_name":
        if (value && value.length > 40) return t("validation.max40chars");
        return value?.trim() === "" ? t("common.required") : "";
      case "first_name":
        if (value && value.length > 40) return t("validation.max40chars");
        return value?.trim() === "" ? t("common.required") : "";
      case "last_name_kana":
        if (value && value.length > 40) return t("validation.max40chars");
        if (!Regex.RULE.KANTAKANA.test(value ?? ""))
          return t("validation.KatakanaRequired");
        return value?.trim() === "" ? t("common.required") : "";
      case "first_name_kana":
        if (value && value.length > 40) return t("validation.max40chars");
        if (!Regex.RULE.KANTAKANA.test(value ?? ""))
          return t("validation.KatakanaRequired");
        return value?.trim() === "" ? t("common.required") : "";
      case "day":
        return value?.trim() === "0" ? t("validation.selectRequired") : "";
      case "month":
        return value?.trim() === "0" ? t("validation.selectRequired") : "";
      case "year":
        return value?.trim() === "0" ? t("validation.selectRequired") : "";
      case "occupationCode":
        return value == "null" ? t("validation.selectRequired") : "";
      case "positionCode":
        return value?.trim() === "" ? t("common.required") : "";
      case "contactType":
        return value?.trim() === "" ? t("common.required") : "";
      default:
        return "";
    }
  };

  const handleChangeFullName = (field: string, value?: string) => {
    setState((prevState) => ({
      ...prevState,
      userMetaData: {
        ...prevState.userMetaData,
        profile: {
          ...prevState?.userMetaData?.profile,
          fullName: {
            ...prevState?.userMetaData?.profile?.fullName,
            [field]: value,
          },
        },
      },
    }));
  };

  const handleChangeFullNameKana = (field: string, value?: string) => {
    setState((prevState) => ({
      ...prevState,
      userMetaData: {
        ...prevState.userMetaData,
        profile: {
          ...prevState.userMetaData?.profile,
          fullNameKana: {
            ...prevState.userMetaData?.profile?.fullNameKana,
            [field]: value,
          },
        },
      },
    }));
  };

  const handleChangeBirth = (field: string, value?: string) => {
    setState((prevState) => ({
      ...prevState,
      userMetaData: {
        ...prevState.userMetaData,
        profile: {
          ...prevState.userMetaData?.profile,
          birth: {
            ...prevState.userMetaData?.profile?.birth,
            [field]: value,
          },
        },
      },
    }));
  };

  const formatDateJapaneseStyle = (
    year?: number,
    month?: number,
    day?: number
  ) => {
    const formattedYear = year?.toString();
    const formattedMonth = month?.toString().padStart(2, "0");
    const formattedDay = day?.toString().padStart(2, "0");

    return `${formattedYear}年 ${formattedMonth}月 ${formattedDay}日`;
  };

  // Handle checkbox in item [職種] in answer screen
  const handleCheckboxChange =
    (value: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const isChecked = event.target.checked;
      setState((prevState) => {
        const currentCodes =
          prevState.userMetaData?.workPlaceInfo?.affiliationCodes ?? [];

        let updatedCodes: string[] = [];
        if (value === "0") {
          updatedCodes = isChecked ? ["0"] : [];
        } else {
          updatedCodes = isChecked
            ? [...currentCodes.filter((code: string) => code !== "0"), value]
            : currentCodes.filter((code: string) => code !== value);
        }

        setErrors((prevErrors) => ({
          ...prevErrors,
          affiliationCodes:
            updatedCodes.length == 0 ? t("common.required") : "",
        }));
        return {
          ...prevState,
          userMetaData: {
            ...prevState.userMetaData,
            workPlaceInfo: {
              ...prevState.userMetaData?.workPlaceInfo,
              affiliationCodes: [...updatedCodes],
            },
          },
        };
      });
    };
  // Render item [職種] in answer screen
  const renderCheckboxGroup = (options: CheckboxOption[]) => {
    const currentCodes = userMetaData?.workPlaceInfo?.affiliationCodes ?? [];

    return (
      <div>
        {options.map((option) => {
          const isChecked = currentCodes.includes(option.value);

          return (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={handleCheckboxChange(option.value)}
                  value={option.value}
                  sx={{
                    color: "#009999",
                    "&.Mui-checked": {
                      color: "#009999",
                    },
                    "& .MuiSvgIcon-root": {
                      fontSize: "16px",
                    },
                  }}
                  size="small"
                />
              }
              label={option.label}
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "14px",
                },
                "& .Mui-checked + .MuiFormControlLabel-label": {
                  fontWeight: "bold",
                },
              }}
            />
          );
        })}
      </div>
    );
  };

  // Render item [役職]
  const renderPositions = () => {
    return positions.map((radio, index) => {
      return (
        <FormControlLabel
          key={index}
          value="1"
          control={
            <Radio
              name="positions"
              value={radio.value}
              size="small"
              sx={{
                color: "#009999",
                "&.Mui-checked": {
                  color: "#009999",
                },
                "& .MuiSvgIcon-root": {
                  fontSize: "15px",
                },
              }}
            />
          }
          label={radio.label}
          sx={{
            "& .MuiFormControlLabel-label": {
              fontWeight: "normal",
              fontSize: 15,
            },
            "& .Mui-checked + .MuiFormControlLabel-label": {
              fontWeight: "bold",
            },
          }}
        />
      );
    });
  };
  // Render item [職種] in confirm screen
  const renderAffiliationSelection = (options: CheckboxOption[]) => {
    const affiliationCodes =
      userMetaData?.workPlaceInfo?.affiliationCodes ?? [];
    const selectedOptions = options.filter((option) =>
      affiliationCodes?.includes(option.value)
    );

    if (selectedOptions.length > 0) {
      return selectedOptions.map((option) => (
        <div key={option.value}>{option.label}</div>
      ));
    }

    return <div>未選択</div>;
  };

  return (
    <div id={id}>
      {isShow ? (
        <div className="component__basic-info">
          <h3
            className="basic-info_title -basic"
            onClick={() => isEdit && handleClickIconVisibleForm("information")}
            style={{ cursor: isEdit ? "pointer" : "default" }}
          >
            <img className="-basic" src="/images/ico_basic.svg" />
            {t("features.userSetting.basicInfo.basicInfoTit")}
            {isEdit && (visibleForms?.information ? <Minus /> : <Plus />)}
          </h3>
          {visibleForms.information ? (
            <dl className="basic-info_body">
              <div
                className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
              >
                <dt className="-middle">
                  <label>
                    <span>{t("features.userSetting.basicInfo.fullName")}</span>
                    {isEdit && (
                      <span className="item_required">
                        {t("general.required")}
                      </span>
                    )}
                  </label>
                </dt>
                <dd>
                  {isEdit ? (
                    <div className="form-col -col2">
                      <div className="form-col_item">
                        <Input
                          maxLength={40}
                          validateMess={errors.last_name}
                          error={errors.last_name}
                          label={t("features.userSetting.basicInfo.surname")}
                          placeholder={t(
                            "features.userSetting.basicInfo.surnamePlaceholder"
                          )}
                          name="last_name"
                          id="last_name"
                          withChecked={true}
                          value={
                            userMetaData?.profile?.fullName?.lastName ||
                            family_name ||
                            ""
                          }
                          onChange={(value) => {
                            handleChangeFullName("lastName", value);
                            const error = validateField("last_name", value);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              last_name: error,
                            }));
                          }}
                        />
                      </div>
                      <div data-name="first_name" className="form-col_item">
                        <Input
                          maxLength={40}
                          validateMess={errors.first_name}
                          error={errors.first_name}
                          label={t("features.userSetting.basicInfo.name")}
                          placeholder={t(
                            "features.userSetting.basicInfo.namePlaceholder"
                          )}
                          name="first_name"
                          id="first_name"
                          value={
                            userMetaData?.profile?.fullName?.firstName ||
                            given_name ||
                            ""
                          }
                          onChange={(value) => {
                            handleChangeFullName("firstName", value);
                            const error = validateField("first_name", value);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              first_name: error,
                            }));
                          }}
                          withChecked={true}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="data-confirm">
                      {userMetaData?.profile?.fullName?.lastName}
                      {userMetaData?.profile?.fullName?.firstName}
                    </div>
                  )}
                </dd>
              </div>

              <div
                className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
              >
                <dt className="-middle">
                  <label>
                    <span>{t("features.userSetting.basicInfo.furigana")}</span>
                    {isEdit && (
                      <span className="item_required">
                        {t("general.required")}
                      </span>
                    )}
                  </label>
                </dt>
                <dd>
                  {isEdit ? (
                    <>
                      <div className="form-col -col2">
                        <div
                          className="form-col_item"
                          data-name="last_name_kana"
                        >
                          <Input
                            maxLength={40}
                            validateMess={errors.last_name_kana}
                            error={errors.last_name_kana}
                            label={t(
                              "features.userSetting.basicInfo.lastNameKana"
                            )}
                            placeholder={t(
                              "features.userSetting.basicInfo.lastNameKanaPlaceholder"
                            )}
                            name="last_name_kana"
                            id="last_name_kana"
                            value={
                              userMetaData?.profile?.fullNameKana?.lastName ??
                              ""
                            }
                            onChange={(value) => {
                              handleChangeFullNameKana("lastName", value);
                              const error = validateField(
                                "last_name_kana",
                                value
                              );
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                last_name_kana: error,
                              }));
                            }}
                            withChecked={true}
                          />
                        </div>

                        <div
                          className="form-col_item"
                          data-name="first_name_kana"
                        >
                          <Input
                            maxLength={40}
                            validateMess={errors.first_name_kana}
                            error={errors.first_name_kana}
                            label={t(
                              "features.userSetting.basicInfo.firstNameKana"
                            )}
                            placeholder={t(
                              "features.userSetting.basicInfo.firstNameKanaPlaceholder"
                            )}
                            name="first_name_kana"
                            id="first_name_kana"
                            value={
                              userMetaData?.profile?.fullNameKana?.firstName ??
                              ""
                            }
                            onChange={(value) => {
                              handleChangeFullNameKana("firstName", value);
                              const error = validateField(
                                "first_name_kana",
                                value
                              );
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                first_name_kana: error,
                              }));
                            }}
                            withChecked={true}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="data-confirm">
                      {userMetaData?.profile?.fullNameKana?.lastName}{" "}
                      {userMetaData?.profile?.fullNameKana?.firstName}
                    </div>
                  )}
                </dd>
              </div>

              <div
                className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
              >
                <dt className="-middle">
                  <label>
                    <span>
                      {isEdit
                        ? t("features.userSetting.basicInfo.birthDay")
                        : t("features.userSetting.basicInfo.gender")}
                    </span>
                    {isEdit && (
                      <span className="item_required">
                        {t("general.required")}
                      </span>
                    )}
                  </label>
                </dt>
                <dd>
                  {isEdit ? (
                    <>
                      <div className="form-col -col2">
                        <div className="form-col_item">
                          <div className="form-input d-flex align-items-center">
                            <Select
                              name="birthday_year"
                              id="birthday_year"
                              className="custom-select"
                              options={years}
                              error={!!errors.year}
                              onChange={(value) => {
                                handleChangeBirth("year", value);
                                const error = validateField("year", value);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  year: error,
                                }));
                              }}
                              defaultValue="0"
                              value={
                                userMetaData?.profile?.birth?.year?.toString() ??
                                ""
                              }
                              customSelect={true}
                            />
                            <Select
                              value={
                                userMetaData?.profile?.birth?.month?.toString() ??
                                ""
                              }
                              className="custom-select"
                              name="birthday_month"
                              id="birthday_month"
                              options={months}
                              error={!!errors.month}
                              defaultValue="0"
                              onChange={(value) => {
                                handleChangeBirth("month", value);
                                const error = validateField("month", value);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  month: error,
                                }));
                              }}
                              customSelect={true}
                            />
                            <Select
                              value={
                                userMetaData?.profile?.birth?.day?.toString() ??
                                "0"
                              }
                              className="custom-select"
                              name="birthday_day"
                              id="birthday_day"
                              error={!!errors.day}
                              defaultValue="0"
                              onChange={(value) => {
                                handleChangeBirth("day", value);
                                const error = validateField("day", value);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  day: error,
                                }));
                              }}
                              options={days}
                              customSelect={true}
                            />
                          </div>
                        </div>
                      </div>
                      <ErrorMsg
                        error={
                          errors.day
                            ? errors.day
                            : errors.month
                            ? errors.month
                            : errors.year
                            ? errors.year
                            : ""
                        }
                        className="invalid-danger"
                      />
                    </>
                  ) : (
                    <div className="data-confirm">
                      {userMetaData?.profile?.genderCode === 1
                        ? t("general.gender.male")
                        : userMetaData?.profile?.genderCode === 2
                        ? t("general.gender.female")
                        : userMetaData?.profile?.genderCode === 3
                        ? t("features.userSetting.basicInfo.noAnswerOption")
                        : ""}
                    </div>
                  )}
                </dd>
              </div>

              <div
                className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
              >
                <dt>
                  <label>
                    <span>
                      {isEdit
                        ? t("features.userSetting.basicInfo.gender")
                        : t("features.userSetting.basicInfo.birthDay")}
                    </span>
                  </label>
                </dt>
                <dd data-name="sex">
                  {isEdit ? (
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={userMetaData?.profile?.genderCode ?? ""}
                        onChange={(e) => {
                          setState((prevState) => ({
                            ...prevState,
                            userMetaData: {
                              ...prevState.userMetaData,
                              profile: {
                                ...prevState?.userMetaData?.profile,
                                genderCode: parseInt(e.target.value),
                              },
                            },
                          }));
                        }}
                      >
                        <FormControlLabel
                          value="1"
                          control={
                            <Radio
                              name="sex"
                              value="1"
                              size="small"
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "15px",
                                },
                              }}
                            />
                          }
                          label={t("general.gender.male")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontWeight: "normal",
                              fontSize: "15px",
                            },
                            "& .Mui-checked + .MuiFormControlLabel-label": {
                              fontWeight: "bold",
                            },
                          }}
                        />
                        <FormControlLabel
                          value="2"
                          control={
                            <Radio
                              size="small"
                              name="sex"
                              value="2"
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "15px",
                                },
                              }}
                            />
                          }
                          label={t("general.gender.female")}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontWeight: "normal",
                              fontSize: "15px",
                            },
                            "& .Mui-checked + .MuiFormControlLabel-label": {
                              fontWeight: "bold",
                            },
                          }}
                        />
                        <FormControlLabel
                          value="3"
                          control={
                            <Radio
                              size="small"
                              name="sex"
                              value="3"
                              sx={{
                                color: "#009999",
                                "&.Mui-checked": {
                                  color: "#009999",
                                },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "15px",
                                },
                              }}
                            />
                          }
                          label={t(
                            "features.userSetting.basicInfo.noAnswerOption"
                          )}
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontWeight: "normal",
                              fontSize: "15px",
                            },
                            "& .Mui-checked + .MuiFormControlLabel-label": {
                              fontWeight: "bold",
                            },
                          }}
                        />
                      </RadioGroup>
                    </FormControl>
                  ) : (
                    <div className="data-confirm">
                      {formatDateJapaneseStyle(
                        userMetaData?.profile?.birth?.year ?? undefined,
                        userMetaData?.profile?.birth?.month ?? undefined,
                        userMetaData?.profile?.birth?.day ?? undefined
                      )}
                    </div>
                  )}
                </dd>
              </div>

              <div
                className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
              >
                <dt className="-middle">
                  <label>
                    <span>{t("features.userSetting.basicInfo.job")}</span>
                    {isEdit && (
                      <span className="item_required">
                        {t("general.required")}
                      </span>
                    )}
                  </label>
                </dt>
                <dd>
                  {isEdit ? (
                    <div className="form-col -col">
                      <div className="form-col_item">
                        <Select
                          value={
                            userMetaData?.profile?.occupationCode?.toString() ??
                            "null"
                          }
                          className="custom-select"
                          name="occupationCode"
                          id="occupationCode"
                          classNameWrapper="col-md-5 min-w-250"
                          onChange={(value) => {
                            setState((prevState) => ({
                              ...prevState,
                              userMetaData: {
                                ...prevState.userMetaData,
                                profile: {
                                  ...prevState?.userMetaData?.profile,
                                  occupationCode: value === "null" ? undefined : parseInt(value),
                                },
                              },
                            }));
                            const error = validateField(
                              "occupationCode",
                              value
                            );
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              occupationCode: error,
                            }));
                          }}
                          error={!!errors.occupationCode}
                          options={occupationSelect}
                          customSelect={true}
                        />
                        <ErrorMsg
                          error={errors.occupationCode}
                          className="invalid-danger"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="data-confirm">
                      {
                        occupationSelect.find(
                          (item) =>
                            item.value ===
                            userMetaData?.profile?.occupationCode?.toString()
                        )?.label
                      }
                    </div>
                  )}
                </dd>
              </div>

              {/* <dl className="basic-interests_body"> */}
              <div
                className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
              >
                <dt className="-middle">
                  <label className="pr0">
                    <span>連絡先種別</span>
                    {isEdit && (
                      <span className="item_required">
                        {t("general.required")}
                      </span>
                    )}
                  </label>
                </dt>
                <dd>
                  {isEdit ? (
                    <>
                      <FormControl>
                        <RadioGroup
                          value={
                            userMetaData?.profile?.contactType?.toString() ?? ""
                          }
                          onChange={(e) => {
                            setState((prevState) => ({
                              ...prevState,
                              userMetaData: {
                                ...prevState.userMetaData,
                                profile: {
                                  ...prevState?.userMetaData?.profile,
                                  contactType: parseInt(e.target.value),
                                },
                              },
                            }));
                            const error = validateField(
                              "contactType",
                              e.target.value
                            );
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              contactType: error,
                            }));
                          }}
                          row
                          name="row-radio-buttons-group"
                        >
                          <FormControlLabel
                            value="2"
                            control={
                              <Radio
                                name="Workplace"
                                value="2"
                                size="small"
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={"勤務先"}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: "15px",
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                          />
                          <FormControlLabel
                            value="1"
                            control={
                              <Radio
                                size="small"
                                name="home"
                                value="1"
                                sx={{
                                  color: "#009999",
                                  "&.Mui-checked": {
                                    color: "#009999",
                                  },
                                  "& .MuiSvgIcon-root": {
                                    fontSize: "15px",
                                  },
                                }}
                              />
                            }
                            label={"自宅"}
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontWeight: "normal",
                                fontSize: "15px",
                              },
                              "& .Mui-checked + .MuiFormControlLabel-label": {
                                fontWeight: "bold",
                              },
                            }}
                          />
                        </RadioGroup>
                      </FormControl>
                    </>
                  ) : (
                    <div>
                      {userMetaData?.profile?.contactType?.toString() === "2"
                        ? "勤務先"
                        : userMetaData?.profile?.contactType?.toString() === "1"
                        ? "自宅"
                        : ""}
                    </div>
                  )}
                  <ErrorMsg
                    error={errors.contactType ? errors.contactType : ""}
                    className="invalid-danger"
                  />
                </dd>
              </div>
              {/* </dl> */}
            </dl>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      {isShowPosition ? (
        <div id={"PositionInfo"} className="component__basic-info">
          <h3
            className="basic-info_title -basic"
            onClick={() => isEdit && handleClickIconVisibleForm("interests")}
            style={{ cursor: isEdit ? "pointer" : "default" }}
          >
            <img className="-basic" src="/images/ico_basic.svg" />
            ご役職・職種
            {isEdit && (visibleForms?.interests ? <Minus /> : <Plus />)}
          </h3>
          {visibleForms.interests ? (
            <dl className="basic-info_body">
              <div
                className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
              >
                <dt className="-px5">
                  <label>
                    {t("features.userSetting.workPlace.position")}
                    {isEdit && (
                      <span className="item_required">
                        {t("general.required")}
                      </span>
                    )}
                  </label>
                </dt>
                <dd>
                  {isEdit ? (
                    <div className="form-col -col2 ">
                      <div className=" w-100 form-col_item">
                        <FormControl>
                          <RadioGroup
                            value={
                              userMetaData?.workPlaceInfo?.positionCode?.toString() ??
                              "0"
                            }
                            onChange={(e) => {
                              setState((prevState) => ({
                                ...prevState,
                                userMetaData: {
                                  ...prevState?.userMetaData,
                                  workPlaceInfo: {
                                    ...prevState?.userMetaData?.workPlaceInfo,
                                    positionCode: e.target.value,
                                  },
                                },
                              }));
                              const error = validateField(
                                "positionCode",
                                e.target.value
                              );
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                positionCode: error,
                              }));
                            }}
                            name="row-radio-buttons-group"
                          >
                            <div>{renderPositions()}</div>
                          </RadioGroup>
                        </FormControl>
                        {/* {errors.positionCode && (
                        <p
                          className="error-text"
                          role="alert"
                          id="error-position-code"
                        >
                          {errors.positionCode ? errors.positionCode : ""}
                        </p>
                      )} */}
                        <ErrorMsg
                          error={errors.positionCode ? errors.positionCode : ""}
                          className="invalid-danger"
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="data-confirm">
                        {
                          positions.find(
                            (item) =>
                              item.value ==
                              userMetaData?.workPlaceInfo?.positionCode?.toString()
                          )?.label
                        }
                      </div>
                    </>
                  )}
                </dd>
              </div>

              <div
                className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
              >
                <dt className="-px5">
                  <label>
                    {t("features.userSetting.workPlace.addJobType")}
                    {isEdit && (
                      <span className="item_required">
                        {t("general.required")}
                      </span>
                    )}
                  </label>
                  {isEdit && (
                    <div className="txt-14 txt-green txt-nomarl mt-2">
                      {t("features.userSetting.workPlace.jobHint")}
                    </div>
                  )}
                </dt>
                <dd>
                  {isEdit ? (
                    <div className="form-col -col2 ">
                      <div className=" w-100 form-col_item">
                        <div className="text-bold">
                          {t(
                            "features.userSetting.workPlace.businessManagementJobs"
                          )}
                        </div>
                        {renderCheckboxGroup(businessAndManagementJobs)}
                        <div className="mt4 text-bold">
                          {t(
                            "features.userSetting.workPlace.creativeDesignJobs"
                          )}
                        </div>
                        {renderCheckboxGroup(creativeAndDesignJobs)}
                        <div className="mt4 text-bold">
                          {t(
                            "features.userSetting.workPlace.environmentInfrastructureJobs"
                          )}
                        </div>
                        {renderCheckboxGroup(environmentAndInfrastructureJobs)}
                        <div className="mt4 text-bold">
                          {t("features.userSetting.workPlace.ITJosb1")}
                        </div>
                        {renderCheckboxGroup(informationAndTechnologyJobs1)}
                        <div className="mt4 text-bold">
                          {t("features.userSetting.workPlace.ITJosb2")}
                        </div>
                        {renderCheckboxGroup(informationAndTechnologyJobs2)}
                        <div className="mt4 text-bold">
                          {t("features.userSetting.workPlace.others")}
                        </div>
                        {renderCheckboxGroup(other)}
                        <ErrorMsg
                          error={errors.affiliationCodes}
                          className="invalid-danger"
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="data-confirm">
                      <div className="txt-gray">
                        {t(
                          "features.userSetting.workPlace.businessManagementJobs"
                        )}
                      </div>
                      {renderAffiliationSelection(businessAndManagementJobs)}

                      <div className="txt-gray mt4">
                        {t("features.userSetting.workPlace.creativeDesignJobs")}
                      </div>
                      {renderAffiliationSelection(creativeAndDesignJobs)}

                      <div className="txt-gray mt4">
                        {t(
                          "features.userSetting.workPlace.environmentInfrastructureJobs"
                        )}
                      </div>
                      {renderAffiliationSelection(
                        environmentAndInfrastructureJobs
                      )}

                      <div className="txt-gray mt4">
                        {t("features.userSetting.workPlace.ITJosb1")}
                      </div>
                      {renderAffiliationSelection(
                        informationAndTechnologyJobs1
                      )}

                      <div className="txt-gray mt4">
                        {t("features.userSetting.workPlace.ITJosb2")}
                      </div>
                      {renderAffiliationSelection(
                        informationAndTechnologyJobs2
                      )}

                      <div className="txt-gray mt4">
                        {t("features.userSetting.workPlace.others")}
                      </div>
                      {renderAffiliationSelection(other)}
                    </div>
                  )}
                </dd>
              </div>
            </dl>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default BasicInfo;
